module.exports = __webpack_public_path__ + "img/card01.f14c3474.png";